<section class="flex flex-col gap-3 bg-white p-4">
    <p class="text-gray-800">서비스를 선택해주세요</p>
    @for (ticket of filterTickets(); track $index) {
        <app-document-select-ticket-item
            (click)="handleSelect(ticket.id)"
            [item]="ticket"
            [active]="ticketId() === ticket.id"
        />
    } @empty {
        <div class="h-[10rem] flex justify-center items-center">
            <p class="text-gray-400">선택 가능한 서비스가 없습니다.</p>
        </div>
    }
</section>
